import React from "react";
import ExamScheduleView from "../pages/schoolCockpit/exam/examSchedule/ExamScheduleView";
import Attendance from "../pages/student/attendance/Attendance";
import HolidayList from "../pages/schoolCockpit/master/holiday/HolidayList";
import UserDashboardResolver from "./UserDashboardResolver";
import GroupCockpitProfile from "../pages/groupCockpit/GroupCockpitProfile";
import MessagingEmail from "../pages/groupCockpit/message/MessagingEmail";
import ChangePassword from "../pages/groupCockpit/ChangePassword";
import ExamResult from "../pages/schoolCockpit/exam/examResult/ExamResult";
import CalendarList from "../pages/schoolCockpit/events/CalendarList";
import StaffTimeTable from "../pages/staff/Master/timeTable/StaffTimeTable";
import ViewAllAnnouncement from "../pages/schoolCockpit/contentManagement/Announcement/ViewAllAnnouncement";
import BookAssessment from "../pages/student/book/BookAssessment";
import ViewRemedialResult from "../pages/student/book/remedial/ViewRemedialResult";
import ViewAssessmentTest from "../pages/student/book/assessment/ViewAssessmentTest";
import ViewStudyMaterial from "../pages/student/book/BooksMaterial/ViewStudyMaterial";
import ViewRemedialTest from "../pages/student/book/remedial/ViewRemedialTest";
import ViewStudentAssessmentResult from "../pages/student/book/assessment/ViewStudentAssessmentResult";
import AiDashboard from "../pages/student/aidashboard/AiDashboard";

// Export routes as configuration array
export const studentRoutes = [
  // Dashboard
  { path: "dashboard", element: <UserDashboardResolver /> },

  // Profile
  { path: "profile", element: <GroupCockpitProfile /> },
  { path: "change-password", element: <ChangePassword /> },

  // Messaging Routes
  { path: "messaging/email", element: <MessagingEmail /> },

  // Academics Routes
  { path: "my-classes/schedule", element: <StaffTimeTable /> },

  // Exams Routes
  { path: "examTimeTable", element: <ExamScheduleView /> },
  { path: "exams/results", element: <ExamResult /> },
  // Dashboard
  { path: "ViewAllAnnouncement", element: <ViewAllAnnouncement /> },

  //Holiday
  { path: "holidayList", element: <HolidayList /> },

  // Attendance
  { path: "attendance", element: <Attendance /> },

  // Events
  { path: "events", element: <CalendarList /> },

  // Assessment
  { path: "assessment", element: <BookAssessment /> },
  {
    path: "viewStudentAssessmentResult",
    element: <ViewStudentAssessmentResult />,
  },
  { path: "ViewAssessmentTest", element: <ViewAssessmentTest /> },

  // Remedial
  { path: "viewStudentRemedialResult", element: <ViewRemedialResult /> },
  { path: "viewRemedialTest", element: <ViewRemedialTest /> },

  //  Study Material
  { path: "viewStudyMaterial", element: <ViewStudyMaterial /> },

  //  AI Dashboard
  { path: "ai-dashboard", element: <AiDashboard /> },
];

export default studentRoutes;
